function $lui(selector) {
    return $.extend($(selector),{"selector":selector});
}